module.exports = __webpack_public_path__ + "static/media/mika-matin.32f833eb.jpg";